/**
 * Attractions grid: filter cards by category pill (one init per section root).
 * Roots: [data-attractions-root] with id starting with attractions-grid-
 */
(function () {
  function forEachNode(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function eventTargetElement(target) {
    if (!target) return null;
    if (target.nodeType === 1) return target;
    return target.parentElement;
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-attractions-js') === '1') return;

    var pills = root.querySelectorAll('button[data-attr-filter]');
    var cards = root.querySelectorAll('[data-attr-card]');
    if (!cards.length || !pills.length) return;

    root.setAttribute('data-attractions-js', '1');

    function setActive(filter) {
      var f = filter == null ? '' : String(filter);
      forEachNode(pills, function (btn) {
        var btnFilter = btn.getAttribute('data-attr-filter') || '';
        var isActive = btnFilter === f;
        btn.classList.toggle('attractions-grid__pill--active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      forEachNode(cards, function (card) {
        var cat = card.getAttribute('data-attr-category') || '';
        var show = f === 'all' || (cat !== '' && cat === f);
        card.hidden = !show;
      });
    }

    root.addEventListener('click', function (e) {
      var el = eventTargetElement(e.target);
      if (!el || typeof el.closest !== 'function') return;
      var pill = el.closest('button[data-attr-filter]');
      if (!pill || !root.contains(pill)) return;
      var next = pill.getAttribute('data-attr-filter');
      if (next != null && next !== '') setActive(next);
    });

    setActive('all');
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-attractions-root][id^="attractions-grid-"]');
    forEachNode(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
